// import React, { useEffect, useRef } from "react";
import "./styles.scss";
import logo from "../../assets/images/logo-upordown_demo.png";
import logoBitLog from "../../assets/images/logo-bitblox.svg";

import LoadingNumber from "./component/loadingNumber";
import { useNavigate } from "react-router-dom";
// import useDeviceDetect from "../../hook/useDeviceDetect";
import { useTheme } from "../../hook/useThemes";
export default function Loading(props) {
  const navigate = useNavigate();
  // const { isMobile } = useDeviceDetect();
  const { settingImage, lang } = useTheme();
  const handleLoadingSuccess = () => {
    // setTimeout(() => {
    //   // if(isMobile){
    //   //   navigate(`/tutorial${window.location.search}`);
    //   //   return;
    //   // };
    //   navigate(`/${window.location.search}`);
    // }, 500);
  };

  return (
    <div className="wrapper-page-loading">
      <img src={settingImage?.logo || logo} className="logo-loading" alt="" />
      <LoadingNumber
        loadingSuccess={handleLoadingSuccess}
        lang={lang}
        number={props?.number}
      />
      <div className="wrap-powered-by">
        <p> {lang?.powered_by || "Powered by"}</p>
        <img src={logoBitLog} className="logo-bitlog" alt="" />
      </div>
    </div>
  );
}
